<script lang="ts">
	import RfAccordion from '@core/elements/rf-accordion/rf-accordion.svelte';

	let { item, inspector = false } = $props();
</script>

<a href="#{item.id}" class="rf-collection-card">
	<div class="rf-collection-card__header">
		<span>
			{#each item.meta.titles as title}
				<strong>
					{title.content} ({title.tag}) - {' '}
				</strong>
			{/each}
			<small>{item.uuid}</small>
			{#if item.id}
				<small>#{item.id}</small>
			{/if}
		</span>
		<span>{item.module.name}</span>
	</div>

	{#each item.meta.descriptions as description}
		<p>{@html description.content}</p>
	{/each}

	{#if !inspector || (inspector && item.canvases.length > 1)}
		<RfAccordion title="Canvases in collection">
			<ul class="rf-collection-card__canvases">
				{#each item.canvases as canvas}
					<li class="canvas-card">
						<ul>
							{#each Object.entries(canvas) as [key, value]}
								{#if typeof value !== 'object'}
									{#if value}
										<li>{key} : {value}</li>
									{/if}
								{:else}
									<ul class="canvas-card__legend">
										<span class="canvas-card__legend__title">Legend</span>
										{#each Object.entries(value || {}) as [legendKey, legendValue]}
											{#if legendValue && typeof legendValue === 'string'}
												<li>{legendKey} : {@html legendValue.trim()}</li>
											{/if}
										{/each}
									</ul>
								{/if}
							{/each}
						</ul>
						{#await canvas.thumbnail then value}
							<img class="canvas-card__image" src={value} alt="" srcset="" />
						{/await}
					</li>
				{/each}
			</ul>
		</RfAccordion>
	{/if}
</a>

<style lang="scss" global>
	.rf-collection-card {
		display: block;
		font-family: var(--rf-font-family);
		margin: 0;
		padding: 0;
		margin-bottom: var(--rf-spacing-s, 8px);
		background-color: var(--rf-inspector-card-bg-color, rgba(50, 50, 50, 0.5));
		padding: var(--rf-spacing-s, 8px);
		list-style: none;
		border-radius: var(--rf-spacing-xs, 4px);

		color: var(--rf-secondary-font-color, #fff);
		text-decoration: none;

		&:hover {
			opacity: 0.8;
		}

		&:last-child {
			margin-bottom: 0;
		}

		&__header {
			display: flex;
			justify-content: space-between;

			small {
				opacity: 0.5;
			}
		}

		&__canvases {
			padding: 0;
			margin: 0;
			width: 100%;
			display: grid;
			grid-template-columns: var(--grid-template, repeat(1, 1fr));
			gap: 1rem;
		}
	}
	.canvas-card {
		position: relative;
		display: flex;
		background-color: #34353c;
		padding: var(--rf-spacing-s, 8px);
		list-style: none;
		border-radius: var(--rf-spacing-xs, 4px);
		padding-right: calc(33% + var(--rf-spacing-s, 8px));
		overflow: hidden;
		margin-bottom: var(--rf-spacing-s, 8px);
		ul {
			padding: 0;
			width: 100%;
		}

		li {
			display: block;
			text-overflow: ellipsis;
			overflow: hidden;
			width: 100%;
			white-space: pre;
			text-transform: capitalize;
		}

		&__legend {
			background-color: #212226;
			width: 100%;
			border-radius: 4px;
			margin: 8px 0;
			box-sizing: border-box;
			padding: 8px !important;

			&__title {
				display: block;
				margin-bottom: 4px;
			}
		}

		&__image {
			position: absolute;
			top: 0;
			right: 0;
			display: block;
			width: 33%;
			height: 100%;
			--rf-canvas-height: 100%;
			cursor: move;
			object-fit: cover;
		}
	}
</style>
